import { ALERT_SEVERITY } from '~/common/constants';

/**
 * An alert generated by an income calculation.
 */
export default class AlertDataModel {
  title: string;
  description: string;
  severity: number;
  calculationScenarioId: number;
  conditionCategory: number;

  constructor(
    cr: {
      title?: string;
      description?: string;
      severity?: number;
      calculationScenarioID?: number;
      conditionCategory?: number;
    } = {},
  ) {
    this.title = 'title' in cr ? cr.title : '';
    this.description = 'description' in cr ? cr.description : '';

    this.severity = 'severity' in cr ? cr.severity : 0;

    this.calculationScenarioId =
      'calculationScenarioID' in cr ? cr.calculationScenarioID : 0;

    this.conditionCategory =
      'conditionCategory' in cr ? cr.conditionCategory : 0;
  }

  /**
   * @returns {string} The alert title.
   */
  getTitle() {
    return this.title;
  }

  /**
   * @returns {string} The alert text.
   */
  getDescription() {
    return this.description;
  }

  /**
   * @returns {string|null} The alert variant based on its severity.
   */
  getSeverity() {
    switch (this.severity) {
      case ALERT_SEVERITY.HINT:
        return 'info';
      case ALERT_SEVERITY.WARNING:
        return 'warning';
      case ALERT_SEVERITY.ALERT:
        return 'error';
      case ALERT_SEVERITY.SUCCESS:
        return 'success';
      case ALERT_SEVERITY.ATTENTION:
        return 'extractionFailed';
      default:
        return null;
    }
  }
}
